module.exports = __webpack_public_path__ + "static/img/index_service_2.58eb3f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SHscreen/index_service_2.png
// module id = XtYX
// module chunks = 4